module.exports = __webpack_public_path__ + "static/phone-bcef8d65642000335b218e62f84d6051.jpg";